function whitelist<T extends { [key: string]: any }>(
  object: T,
  allowedProperties: Array<keyof T>,
): Partial<T> {
  return Object
    .keys(object)
    .filter(key => allowedProperties.includes(key))
    .reduce((acc, val) => {
      acc[val] = object[val]
      return acc
    }, {})
}

export default whitelist
